import { useInfiniteQuery } from '@tanstack/react-query';
import { getActivities } from '@api/activityApi';
import { ActivityFeedScope } from '@api/activityApi/interfaces';

export const useGetActivityFeed = ({
  perPage,
  scope = null,
}: {
  perPage: number;
  scope?: ActivityFeedScope | null;
}) => {
  return useInfiniteQuery({
    queryKey: ['activity-feed', { perPage, scope }],

    queryFn: ({ pageParam = null }: { pageParam: string | null }) => {
      return getActivities(perPage, pageParam, scope);
    },

    initialPageParam: null,

    getNextPageParam: (lastPage) => {
      if (!lastPage.meta.hasMore) return undefined;
      return lastPage.meta.nextCursor;
    },

    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
};
